module.exports = __webpack_public_path__ + "static/media/light.2011d10e.png";